import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import request from '../ct-request';
import { getPhoneDigitsOnly } from '../utils';

const useAddresses = () => {
  const dispatch = useDispatch();
  const customerId = useSelector((state) => state.accounts.user.id);

  useEffect(() => {
    async function fetchAddresses() {
      try {
        const ctAddresses = await request({
          uri: 'customers/addresses',
          options: {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              customerId,
            },
          },
        });

        const sortedAddresses = ctAddresses?.sort((a, b) => {
          const keyA = a.isDefaultShippingAddress;
          const keyB = b.isDefaultShippingAddress;
          if (keyA === true) return -1;
          if (keyB === true) return 1;
          return 0;
        })?.map((address) => ({
          ...address,
          phone: getPhoneDigitsOnly(address.phone),
        }));

        dispatch({ type: 'accounts/updateAddresses', payload: sortedAddresses });
        dispatch({ type: 'accounts/setUserAddressesFetched', payload: true });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }

    if (customerId) {
      fetchAddresses();
    }
  }, [customerId, dispatch]);

  return useSelector((state) => state.accounts.user.addresses);
};
export default useAddresses;
